import { createFileRoute, retainSearchParams } from '@tanstack/react-router'

import { VerifyCodeError } from '@/components/error-communications'
import { exchangeSearchSchema } from '@/lib/searchSchemas/exchange'
import { getTrackIdQueryOptions } from '@/queries/auth'

export const Route = createFileRoute(
  `/_unauthenticated/registration/organizations/$orgId/exchange`
)({
  validateSearch: exchangeSearchSchema,
  loaderDeps: ({ search }) => ({
    token: search.token,
  }),
  beforeLoad: ({ context: { orgStore }, params }) =>
    orgStore.getState().setOrgId(params.orgId),
  loader: async ({ context: { queryClient }, deps: { token }, params }) => {
    queryClient.ensureQueryData(
      getTrackIdQueryOptions({ orgId: params.orgId, token: token! })
    )
  },
  search: { middlewares: [retainSearchParams(true)] },
  errorComponent: VerifyCodeError,
})
